import TextArea from "../../../UI/TextArea";
import Callout from "../../../UI/Callout";
import styles from "./CongeLegitime.module.css";

export default function CongeLegitime() {
  return (
    <div className={styles.root}>
      <Callout variant="warning">
        Un congé ne peut avoir lieu qu'a l'échéance du bail. il doit être envoyé
        :
        <ul>
          <li>
            Pour un logement meublé, au moins 3 mois avant l'échéance du bail
          </li>
          <li>Pour un logement nu, au moins 6 mois avant l'échéance du bail</li>
        </ul>
      </Callout>
      <Callout variant="neutral">
        Exemples de motif :
        <ul>
          <li>Retard de loyers fréquent</li>
          <li>N'a pas communiqué son attestation d'assurance multirisque</li>
          <li>Trouble du voisinage</li>
          <li>
            travaux de rénovation total du logement à effectuer pour respecter
            les critère de décence du DPE
          </li>
        </ul>
      </Callout>

      <TextArea
        type="text"
        name="motif"
        label="Motif du congé"
        placeholder="Retard de loyers fréquent"
      />
    </div>
  );
}
